import Platform from "../../../../../libs/utility/Platform"
import { Theme } from "../../../../components/constants" 

export default {
    createFormContainer: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        justifyContent:"space-between",
        height:"87vh"
    },
    bodyContainer: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
    },
    headerRow: {
        display: "flex",
        flexDirection: "row",
        margin: "0px 0px 10px 0px"
    },
    searchRow: {
        marginTop: "10px",
        width: Platform.isMobileView() ? "100%" : "500px",
        padding: "20px 0px 10px",
    },
    nextButtonDiv: {
        marginTop: "10px",
        display: "flex",
        justifyContent: "flex-end",
        minHeight: "35px",
    },
    cardNextBtnDiv: {
        position: "absolute",
        bottom: "10px"
    },
    yearSelectionRowContainer:{
        display: "flex",
        justifyContent: "space-between",
        flexWrap:"wrap",
        rowGap:"20px"
    },
    yearSelectionRow: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        marginTop: "10px",
        justifyContent: "flex-start",
        gap: "10px",
    },
    yearBox: {
        position: "relative",
        background: "#FFFFFF",
        boxShadow: "0px 10px 10px rgba(38, 38, 38, 0.05)",
        borderRadius: "12px",
        width: "160px",
        // height: "125px",
        height: "70px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        color: Theme.TEXT_PRIMARY_BLACK,
    },
    selectedYearBox: {
        background: Theme.PRIMARY,
        color: Theme.TEXT_WHITE,
    },
    formSelectionRow: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        marginTop: "30px",
        gap: "10px",
        marginBottom: "20px",
    },
    formNameStyles: {
        marginTop: "10px",
        height: "30px",
    },
    formBox: {
        width: "160px",
        height: "160px",
        background: "rgba(65, 182, 115, 0.1)",
        display: "flex",
        flexDirection:"column",
        alignItems: "center",
        // justifyContent: "center",
        cursor: "pointer",
        textAlign: "center",
        padding: "5px",
        position:"relative"
    },
    formBoxDesc: {
        fontWeight: 400,
        lineHeight: "24px",
    },
    selectedFormBox: {
        width: "175px",
        height: "175px",
        background: "#41B673",
        color: Theme.TEXT_WHITE,
        marginTop: "-10px",
    },
    recommendCardContainer: {
        width: Platform.isMobileView() ? "100%" : "50%",
        display: "flex",
        justifyContent: "flex-end",
        marginRight: "50px",
    }
}